exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/www/kh_indesso_web/~/css-loader?{"sourceMap":false,"importLoaders":1}!D:/www/kh_indesso_web/~/postcss-loader?{"ident":"postcss"}!D:/www/kh_indesso_web/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 3